import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import RouteStepper from './RouteStepper';

export default function TripRateLayout() {
    return (
        <Box height="100%" overflow="hidden" flexDirection="column" display="flex">
            <Box>
                <RouteStepper />
            </Box>
            <Box flexGrow={1} overflow="hidden">
                <Box height="100%" overflow="auto" padding={1}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}